module.exports = __webpack_public_path__ + "img/SKMJ_sticker2.08a20b04.png";